import React from 'react';
import axios from 'axios';
import qs from 'qs';
import moment from 'moment';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import { withSnackbar } from 'notistack';
import {
  DatePicker,
  DateTimePicker,
} from '@material-ui/pickers';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import Slide from '@material-ui/core/Slide';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import CircularProgress from '@material-ui/core/CircularProgress';
import { setData } from '../../../actions/index';

const styles = theme => ({
  closeIcon: {
    position: 'absolute',
    right: 20,
    top: 20,
  },
  content: {
    padding: isMobileApp
      ? 20
      : '80px 80px 20px',
    margin: '10px auto',
    width: '100%',
    textAlign: 'left',
    color: '#222222',
    boxSizing: 'border-box',
  },
  formGroup: {
    marginBottom: 30,
  },
  formControl: {
    minWidth: 240,
  },
  breakWord: {
    wordWrap: 'break-word',
  },
  buttonIcon: {
    marginBottom: -7,
  },
  closeButtonIcon: {
    float: 'right',
    marginBottom: -7,
  },
});

const mapStateToProps = state => {
  return {
    user: state.user,
    selectedPupil: state.selectedPupil,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    setData: (data, type) => dispatch(setData(data, type)),
  };
}

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

class CovidTestsDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      testDate: new Date(),
      barcode: '',
      symptoms: '',
      symptomsDate: new Date(),
      result: '',
      note: '',
      submitting: false,
    };

    this.axiosCancel = null;

    this.onChange = this.onChange.bind(this);
    this.onSubmitButtonClick = this.onSubmitButtonClick.bind(this);
  }

  componentWillUnmount() {
    if (this.axiosCancel) {
      this.axiosCancel();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.data &&
      this.props.data !== prevProps.data
    ) {
      this.setState({
        testDate: moment(this.props.data.test_date).toDate(),
        barcode: this.props.data.barcode,
        symptoms: this.props.data.symptoms,
        symptomsDate: this.props.data.symptoms_date
          ? moment(this.props.data.symptoms_date).toDate()
          : null,
        result: this.props.data.result,
        note: this.props.data.note,
      });
    } else if (this.props.isDialogOpen !== prevProps.isDialogOpen) {
      this.setState({
        testDate: new Date(),
        barcode: '',
        symptoms: '',
        symptomsDate: new Date(),
        result: '',
        note: '',
        submitting: false,
      });
    }
  }

  onChange(event) {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({
      [name]: value,
    });
  }


  onSubmitButtonClick() {
    const {
      t,
      selectedPupil,
      onDialogClose,
      reloadData,
      enqueueSnackbar,
    } = this.props;
    const {
      testDate,
      barcode,
      symptoms,
      symptomsDate,
      result,
      note,
    } = this.state;

    if (!selectedPupil) {
      return;
    }

    this.setState({
      submitting: true,
    });

    const url = `${window.apiUrl}/recordcovidtest`;
    const params = {
      pupil_id: selectedPupil.id,
      date: testDate
        ? moment(testDate).format(dateFormat + ' HH:mm')
        : '',
      barcode,
      symptoms,
      symptoms_date: symptoms === 'yes' && symptomsDate
        ? moment(symptomsDate).format(dateFormat)
        : '',
      result,
      note,
    };

    return axios
      .post(
        url,
        qs.stringify(params),
        {
          cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
        }
      ).then((response) => {
        if (response.data.error) {
          enqueueSnackbar(response.data.error, {
            variant: 'error',
            autoHideDuration: 2000,
          });
        } else {
          enqueueSnackbar(t('You have successfully saved the COVID test'), {
            variant: 'success',
            autoHideDuration: 2000,
          });

          this.setState({
            date: new Date(),
            reason: '',
          });

          onDialogClose();
          reloadData();
        }

        this.setState({
          submitting: true,
        });
      })
      .catch((thrown) => {});
  }

  render() {
    const {
      testDate,
      barcode,
      symptoms,
      symptomsDate,
      result,
      note,
      submitting,
    } = this.state;
    const {
      classes,
      t,
      isDialogOpen,
      onDialogClose,
    } = this.props;

    return (
      <Dialog
        fullScreen={isMobileApp}
        scroll="paper"
        open={isDialogOpen}
        fullWidth
        maxWidth="md"
        onClose={onDialogClose}
        TransitionComponent={Transition}
        className="covid-tests-dialog"
      >
        <IconButton
          aria-label="Close"
          onClick={onDialogClose}
          className={`covid-tests-dialog-close-button ${classes.closeIcon}`}
        >
          <CloseIcon />
        </IconButton>
        <div className={classes.content}>
          <div className={classes.formGroup}>
            <DateTimePicker
              disableToolbar
              disableFuture
              ampm={false}
              format={dateFormat + ' HH:mm'}
              id="test-date-picker"
              label={t('Test date')}
              value={testDate}
              onChange={(date) => {
                this.setState({
                  testDate: date,
                });
              }}
            />
          </div>
          <div className={classes.formGroup}>
            <TextField
              autoFocus
              fullWidth
              label={t('Test barcode/serial number (optional)')}
              name="barcode"
              value={barcode}
              onChange={this.onChange}
            />
          </div>
          <div className={classes.formGroup}>
            <FormControl className={classes.formControl}>
              <InputLabel id="symptoms">{t('Showing symptoms (optional)')}</InputLabel>
              <Select
                labelId="symptoms"
                value={symptoms}
                name="symptoms"
                onChange={this.onChange}
              >
                <MenuItem value="">{t('-- none --')}</MenuItem>
                <MenuItem value="no">{t('No')}</MenuItem>
                <MenuItem value="yes">{t('Yes')}</MenuItem>
              </Select>
            </FormControl>
          </div>
          {symptoms === 'yes' && (
            <div className={classes.formGroup}>
              <DatePicker
                disableToolbar
                disableFuture
                format={dateFormat}
                id="symptoms-date-picker"
                label={t('Symptoms started')}
                value={symptomsDate}
                onChange={(date) => {
                  this.setState({
                    symptomsDate: date,
                  });
                }}
              />
            </div>
          )}
          <div className={classes.formGroup}>
            <FormControl className={classes.formControl}>
              <InputLabel id="result">{t('Result (optional)')}</InputLabel>
              <Select
                labelId="result"
                value={result}
                name="result"
                onChange={this.onChange}
              >
                <MenuItem value="">{t('-- none --')}</MenuItem>
                <MenuItem value="positive">{t('Positive')}</MenuItem>
                <MenuItem value="negative">{t('Negative')}</MenuItem>
                <MenuItem value="void">{t('Void')}</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className={classes.formGroup}>
            <TextField
              autoFocus
              fullWidth
              label={t('Note (optional)')}
              name="note"
              value={note}
              onChange={this.onChange}
            />
          </div>
        </div>
        <DialogActions>
          <Button
            onClick={this.onSubmitButtonClick}
            color="primary"
            disabled={submitting}
            className="covid-tests-dialog-submit-button"
          >
            {submitting && (
              <>
                <CircularProgress size={14} />
                <span> {t('Submitting ...')}</span>
              </>
            )}
            {!submitting && t('Submit')}
          </Button>
          <Button
            onClick={onDialogClose}
            className="covid-tests-dialog-cancel-button"
          >
            {t('Cancel')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(withSnackbar(withTranslation()(CovidTestsDialog)))
);
